import { useState } from "react";
import { currency, discountIsValid, timeAgo } from "../../utils/mappers";
import { Button, Card, Image, Modal, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { FiGrid } from "react-icons/fi";
import { MdBlock, MdRefresh } from "react-icons/md";
import { RatingStars } from "../RatingStars";
import "./styles.scss";
import { getImage, markProductsAsEnded } from "../../services/api";
import useAuth from "../../contexts/auth";
import useNotification from "../../contexts/notification";
import useEndedSelection from "../../contexts/endedSelection";




export default function ProductCard({ product, onChange }) {
  const history = useHistory();
  const { user } = useAuth();
  const { setMessage } = useNotification();
  const { selectedIds, toggleSelection } = useEndedSelection();

  const showDiscountInfo = product.price_on_offer == 1 ? true : false;
  const [endedLocal, setEndedLocal] = useState(Boolean(product.oferta_encerrada));
  const isEnded = endedLocal;
  const canManage = user && user.type && user.type !== "client";
  const isSelected = (selectedIds || []).includes(product.id);

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [isApplying, setIsApplying] = useState(false);

  function openConfirm(e) {
    e.stopPropagation();
    e.preventDefault();
    setConfirmOpen(true);
  }

  function closeConfirm() {
    if (isApplying) return;
    setConfirmOpen(false);
  }

  async function applyConfirmed() {
    const willEnd = !isEnded;
    setIsApplying(true);
    try {
      await markProductsAsEnded([product.id], willEnd);
      setEndedLocal(willEnd);
      setMessage({
        error: false,
        content: willEnd ? "Oferta marcada como encerrada." : "Oferta reativada.",
      });
      if (typeof onChange === "function") onChange(product.id, willEnd);
      setConfirmOpen(false);
    } catch (err) {
      setMessage({ error: true, content: "Erro ao atualizar a oferta. Tente novamente." });
    } finally {
      setIsApplying(false);
    }
  }

  function handleCheckboxClick(e) {
    e.stopPropagation();
    e.preventDefault();
    if (typeof toggleSelection === "function") toggleSelection(product.id);
  }


  return (
    <Card
      className={`my-1 card-product ${isEnded ? "is-ended-offer" : ""}`}
      title={isEnded ? "Oferta encerrada — clique para ver detalhes" : `Ver detalhes de ${product.name}`}
      onClick={() => {
        return history.push(`/produto/${product.id}`);
      }}
      style={isEnded ? { position: "relative" } : {}}
    >
      <Image
        src={(product.image_url)}
        className="product-card-image"
        style={isEnded ? { filter: "grayscale(1)", opacity: 0.55 } : {}}
      />
      {canManage ? (
        <label
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: 8,
            left: 8,
            zIndex: 35,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 28,
            height: 28,
            background: isSelected ? "#28a745" : "rgba(255,255,255,0.95)",
            border: isSelected ? "2px solid #28a745" : "2px solid #adb5bd",
            borderRadius: 6,
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.18)",
            margin: 0,
          }}
          title={isSelected ? "Desmarcar" : "Marcar para ação em massa"}
        >
          <input
            type="checkbox"
            checked={isSelected}
            onChange={handleCheckboxClick}
            onClick={(e) => e.stopPropagation()}
            style={{
              opacity: 0,
              position: "absolute",
              pointerEvents: "none",
            }}
          />
          {isSelected ? (
            <span style={{ color: "#fff", fontWeight: 800, fontSize: "1rem", lineHeight: 1 }}>✓</span>
          ) : null}
        </label>
      ) : null}
      {isEnded ? (
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(170, 170, 170, 0.92)",
          color: "#fff",
          padding: "6px 16px",
          borderRadius: 999,
          fontWeight: 600,
          fontSize: "0.85rem",
          letterSpacing: "0.02em",
          boxShadow: "0 2px 8px rgba(0,0,0,0.18)",
          zIndex: 20,
          pointerEvents: "none",
        }}>
          Encerrada
        </div>
      ) : null}
      {canManage ? (
        <button
          type="button"
          onClick={openConfirm}
          title={isEnded ? "Reativar oferta" : "Marcar como encerrada"}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 30,
            border: "none",
            background: isEnded ? "#28a745" : "rgba(33, 37, 41, 0.85)",
            color: "#fff",
            padding: "6px 8px",
            borderRadius: 6,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: 4,
            fontSize: "0.78rem",
            fontWeight: 700,
            boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
          }}
        >
          {isEnded ? <MdRefresh size={16} /> : <MdBlock size={16} />}
          <span>{isEnded ? "Reativar" : "Encerrar"}</span>
        </button>
      ) : null}
      {product.partner && product.partner.image_url && (
        <div className="partner-logo-container">
          <Image src={product.partner.image_url} className="partner-logo" alt={`Logo de ${product.partner.name}`} />
        </div>
      )}
      {product.ribbon_badges && product.ribbon_badges.length > 0 && product.ribbon_badges.map((badge) => (
        <span key={badge.id} className="ribbon-badge" style={{
          position: 'absolute',
          top: '5px', // Posicionado um pouco para baixo para simular o estilo na imagem
          left: '1px', // Posicionado à direita
          backgroundColor: badge.color,
          color: '#fff',
          padding: '5px 20px',

          border: '1px solid #ddd',
          borderRadius: '5px',
          overflow: 'hidden',
          textTransform: 'uppercase',
          fontSize: '14px',
          fontWeight: 'bold',
          // Texto centralizado
          boxShadow: '5px 2px 5px rgba(0,0,0,0.4)',
          zIndex: 10
        }}>
          {badge.name}

        </span>
      ))}



      <Card.Body style={isEnded ? { filter: "grayscale(1)", opacity: 0.7 } : {}}>
        <Card.Title className="" style={{ fontWeight: 'bold', fontSize: '17px', color: 'black' }}>


          {product.name}



        </Card.Title>


        Postado {timeAgo(product.created_at)}


        {Number(product.previous_price) > 0 && showDiscountInfo && (
          <p className="old-price">{currency(product.previous_price)}</p>
        )}

        <div className=" price h6" style={{ fontWeight: 'bold', fontSize: '25px', color: 'green' }}>
          {currency(
            showDiscountInfo ? product.offer_price : product.previous_price
          )}

          {showDiscountInfo && (
            <span className="h6 bg-primary text-light p-1 rounded ml-2" style={{ fontSize: '11px' }}>Oferta </span>
          )}
        </div>




        {product.categoryName && (

          <div className="d-flex justify-content-center align-items-center">
            <FiGrid className="text-muted" size={16} />
            <span className="ml-1 text-muted">{product.categoryName}</span>
          </div>

        )}

      </Card.Body>
      <Modal
        show={confirmOpen}
        onHide={closeConfirm}
        centered
        onClick={(e) => e.stopPropagation()}
      >
        <Modal.Header closeButton={!isApplying}>
          <Modal.Title>{isEnded ? "Reativar oferta" : "Encerrar oferta"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2"><strong>{product.name}</strong></p>
          <p className="mb-0 text-muted">
            {isEnded
              ? "A oferta voltará a ficar visível e clicável na vitrine."
              : "A oferta vai aparecer em cinza com selo \"Encerrada\" na vitrine, e o link de compra ficará bloqueado."}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closeConfirm} disabled={isApplying}>
            Cancelar
          </Button>
          <Button
            variant={isEnded ? "success" : "secondary"}
            onClick={applyConfirmed}
            disabled={isApplying}
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            {isApplying ? (
              <>
                <Spinner animation="border" size="sm" /> Aplicando...
              </>
            ) : (
              <>
                {isEnded ? <MdRefresh /> : <MdBlock />}
                Confirmar
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
}
